/* eslint-disable no-console */
import {
  FeedbackAgeGroup,
  FeedbackAuthenticationType,
  FeedbackHostPlatformType,
  FeedbackPolicyValue,
  FeedbackUiType,
  IFeedbackInitOptions,
  InAppFeedbackScenarioType,
  OcvFeedbackType,
  InAppFeedbackQuestionUiType,
  InAppFeedbackQuestionUiBehaviour,
} from './FeedbackTypes';

export const OCV_MICROSOFT_APP_ID = 2482;
export const OCV_MICROSOFT_CLIENT_NAME = 'MicrosoftAdvertising';

export const defaultThumbUpFeedbackOptions: IFeedbackInitOptions = {
  ageGroup: FeedbackAgeGroup.Adult,
  authenticationType: FeedbackAuthenticationType.AAD,
  feedbackConfig: {
    complianceChecks: {
      connectedExperiences: FeedbackPolicyValue.Enabled,
      policyAllowContact: FeedbackPolicyValue.Enabled,
      policyAllowContent: FeedbackPolicyValue.Enabled,
      policyAllowFeedback: FeedbackPolicyValue.Enabled,
      policyAllowScreenshot: FeedbackPolicyValue.Enabled,
      policyAllowSurvey: FeedbackPolicyValue.Enabled,
    },
    feedbackUiType: FeedbackUiType.Modal,
    initialFeedbackType: OcvFeedbackType.Smile,
    hostPlatform: FeedbackHostPlatformType.Web,
    isDisplayed: false,
    isEmailCollectionEnabled: false,
    isFeedbackForumEnabled: false,
    isFileUploadEnabled: false,
    isMyFeedbackEnabled: false,
    isScreenshotEnabled: false,
    isScreenRecordingEnabled: false,
    isShareContextDataEnabled: true,
    isThankYouPageDisabled: true,
    maxHeight: 'calc(100% - 32px)',
    scenarioConfig: {
      isScenarioEnabled: true,
      scenarioType: InAppFeedbackScenarioType.AIThumbsUp,
    },
  },
  themeOptions: { baseTheme: 'FabricDefaultTheme' },
  isProduction: true,
  appId: 50819,
  clientName: 'OcvFeedbackDemoHostingApp',
};

export const defaultThumbDownFeedbackOptions: IFeedbackInitOptions = {
  ageGroup: FeedbackAgeGroup.Adult,
  authenticationType: FeedbackAuthenticationType.AAD,
  feedbackConfig: {
    complianceChecks: {
      connectedExperiences: FeedbackPolicyValue.Enabled,
      policyAllowContact: FeedbackPolicyValue.Enabled,
      policyAllowContent: FeedbackPolicyValue.Enabled,
      policyAllowFeedback: FeedbackPolicyValue.Enabled,
      policyAllowScreenshot: FeedbackPolicyValue.Enabled,
      policyAllowSurvey: FeedbackPolicyValue.Enabled,
    },
    feedbackUiType: FeedbackUiType.Modal,
    initialFeedbackType: OcvFeedbackType.Frown,
    hostPlatform: FeedbackHostPlatformType.Web,
    isDisplayed: false,
    isEmailCollectionEnabled: false,
    isFeedbackForumEnabled: false,
    isFileUploadEnabled: false,
    isMyFeedbackEnabled: false,
    isScreenshotEnabled: false,
    isScreenRecordingEnabled: false,
    isShareContextDataEnabled: true,
    isThankYouPageDisabled: true,
    maxHeight: 'calc(100% - 32px)',
    scenarioConfig: {
      isScenarioEnabled: true,
      scenarioType: InAppFeedbackScenarioType.AIThumbsDown,
    },
  },
  themeOptions: { baseTheme: 'FabricDefaultTheme' },
  isProduction: true,
  appId: 50819,
  clientName: 'OcvFeedbackDemoHostingApp',
};

export const defaultProductFeedbackOptions: IFeedbackInitOptions = {
  ageGroup: FeedbackAgeGroup.Adult,
  authenticationType: FeedbackAuthenticationType.AAD,
  feedbackConfig: {
    complianceChecks: {
      connectedExperiences: FeedbackPolicyValue.Enabled,
      policyAllowContact: FeedbackPolicyValue.Enabled,
      policyAllowContent: FeedbackPolicyValue.Enabled,
      policyAllowFeedback: FeedbackPolicyValue.Enabled,
      policyAllowScreenshot: FeedbackPolicyValue.Enabled,
      policyAllowSurvey: FeedbackPolicyValue.Enabled,
    },
    feedbackUiType: FeedbackUiType.Modal,
    initialFeedbackType: OcvFeedbackType.Idea,
    hostPlatform: FeedbackHostPlatformType.Web,
    isDisplayed: false,
    isEmailCollectionEnabled: false,
    isFeedbackForumEnabled: false,
    isFileUploadEnabled: false,
    isMyFeedbackEnabled: false,
    isScreenshotEnabled: false,
    isScreenRecordingEnabled: false,
    isShareContextDataEnabled: true,
    isThankYouPageDisabled: true,
    maxHeight: 'calc(100% - 32px)',
    scenarioConfig: {
      isScenarioEnabled: true,
      scenarioType: InAppFeedbackScenarioType.Custom,
      questionDetails: {
        questionUiType: InAppFeedbackQuestionUiType.SingleSelect,
        questionInstruction: {
          displayedString: 'How satisfied are you with Chat Copilot for Microsoft Advertising?',
          displayedStringInEnglish: 'How satisfied are you with Chat Copilot for Microsoft Advertising?',
        },
        questionOptions: [{
          displayedString: 'Very Satisfied',
          displayedStringInEnglish: 'Very Satisfied',
        }, {
          displayedString: 'Moderately Satisfied',
          displayedStringInEnglish: 'Moderately Satisfied',
        }, {
          displayedString: 'Neither satisfied nor dissatisfied',
          displayedStringInEnglish: 'Neither satisfied nor dissatisfied',
        }, {
          displayedString: 'Moderately Dissatisfied',
          displayedStringInEnglish: 'Moderately Dissatisfied',
        }, {
          displayedString: 'Very Dissatisfied',
          displayedStringInEnglish: 'Very Dissatisfied',
        }],
        questionUiBehaviour: [InAppFeedbackQuestionUiBehaviour.CommentRequiredWithLastOption],
      },
    },
  },
  themeOptions: { baseTheme: 'FabricDefaultTheme' },
  isProduction: true,
  appId: 50819,
  clientName: 'OcvFeedbackDemoHostingApp',
};
